import React, { useState, useMemo } from 'react';
import './Table.css';

const Table = () => {
  const initialData = [
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L1', empresa: 'BAF', id: 'BV1_L1_T1_CC78_C1', piezas: 2186, pesoKs: 89.2, corral: 'CC78' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L2', empresa: 'SER', id: 'BV1_L2_T1_Servax_C1', piezas: 7396, pesoKs: 62, corral: 'Servax' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L2', empresa: 'SER', id: 'BV1_L2_T2_Servax_C1', piezas: 1777, pesoKs: 64.1, corral: 'Servax' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L3', empresa: 'BAF', id: 'BV1_L3_T1_CC38_C1', piezas: 5438, pesoKs: 49.7, corral: 'CC38' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L3', empresa: 'BAF', id: 'BVI_L3_T2_CC45_C1', piezas: 6521, pesoKs: 52.7, corral: 'CC45' }, 
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L5', empresa: 'BAF', id: 'BV2_L5_T1_CC64_C1', piezas: 612, pesoKs: 84.6, corral: 'CC64' }, 
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L5', empresa: 'BAF', id: 'BV1_L5_T1_CC65_C1', piezas: 2835, pesoKs: 75.5, corral: 'CC65' }, 
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L5', empresa: 'BAF', id: 'BV1_L5_T2_CC64_C1', piezas: 719, pesoKs: 74.5, corral: 'CC64' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L6', empresa: 'BAF', id: 'BV2_L6_T1_CC81_C1', piezas: 942, pesoKs: 56.4, corral: 'CC81' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L6', empresa: 'BAF', id: 'BVI_L6_T1_CC43_C3', piezas: 2186, pesoKs: 60.6, corral: 'CC43' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L6', empresa: 'SER', id: 'BV1_L6_T2_SERVAX_C1', piezas: 5657, pesoKs: 63.1, corral: 'SERVAX' },      
  ];

  const [filters, setFilters] = useState({});
  const [globalSearch, setGlobalSearch] = useState('');
  const [sortConfig, setSortConfig] = useState(null);

  const handleFilterChange = (col, val) => {
    setFilters(prev => ({ ...prev, [col]: val.toLowerCase() }));
  };

  const handleGlobalSearch = (e) => {
    setGlobalSearch(e.target.value.toLowerCase());
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig?.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const processedData = useMemo(() => {
    let data = initialData.map(item => ({
      ...item,
      biomasa: (item.piezas * item.pesoKs) / 1000,
    }));

    // Global search
    if (globalSearch) {
      data = data.filter(item =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(globalSearch)
        )
      );
    }

    // Column filters
    data = data.filter(item =>
      Object.keys(filters).every(key =>
        String(item[key]).toLowerCase().includes(filters[key])
      )
    );

    return data;
  }, [filters, globalSearch]);

  const sortedData = useMemo(() => {
    if (!sortConfig) return processedData;
    return [...processedData].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [processedData, sortConfig]);

  const totals = useMemo(() => sortedData.reduce(
    (acc, curr) => ({
      piezas: acc.piezas + Number(curr.piezas),
      biomasa: acc.biomasa + curr.biomasa,
    }),
    { piezas: 0, biomasa: 0 }
  ), [sortedData]);

  const columns = [
    { key: 'bloque', label: 'Bloque' },
    { key: 'barco', label: 'Barco' },
    { key: 'lance', label: 'Lance' },
    { key: 'empresa', label: 'Empresa' },
    { key: 'id', label: 'ID Transacción' },
    { key: 'piezas', label: 'Piezas' },
    { key: 'pesoKs', label: 'Peso (kg)' },
    { key: 'biomasa', label: 'Biomasa (T)' },
    { key: 'corral', label: 'Corral' },
  ];

  return (
    <div className="dashboard-wrapper">
      <header className="dashboard-header">
        <div className="title-section">
          <h1>TABLA MAESTRA <span className="highlight">LANCES</span></h1>
          <p className="subtitle">Control de Biomasa y Captura Operativa | Buenaventura Fleet</p>
        </div>

        <div className="summary-cards">
          <div className="card">
            <div className="card-label">Total Piezas</div>
            <div className="card-value">{totals.piezas.toLocaleString('hr-HR')}</div>
          </div>
          <div className="card highlight-card">
            <div className="card-label">Total Biomasa (T)</div>
            <div className="card-value">
              {totals.biomasa.toLocaleString('hr-HR', { minimumFractionDigits: 2 })}
            </div>
          </div>
        </div>
      </header>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search globally"
          value={globalSearch}
          onChange={handleGlobalSearch}
          className="global-search"
        />
      </div>

      <div className="table-wrapper">
        {sortedData.length === 0 ? (
          <div className="empty-state">
            <p>No result</p>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                {columns.map(col => (
                  <th
                    key={col.key}
                    onClick={() => handleSort(col.key)}
                    className={`sortable ${sortConfig?.key === col.key ? sortConfig.direction : ''}`}
                  >
                    {col.label}
                    {sortConfig?.key === col.key && (
                      sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
                    )}
                    <input
                      type="text"
                      className="filter-input"
                      placeholder="Filter"
                      onChange={e => handleFilterChange(col.key, e.target.value)}
                    />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, i) => (
                <tr key={i} className="row-item">
                  <td data-label="Bloque"><span className="badge-bloque">{row.bloque}</span></td>
                  <td data-label="Barco" className="text-bold">{row.barco}</td>
                  <td data-label="Lance"><span className="badge-lance">{row.lance}</span></td>
                  <td data-label="Empresa"><span className="badge-empresa">{row.empresa}</span></td>
                  <td data-label="ID Transacción" className="text-id">{row.id}</td>
                  <td data-label="Piezas" className="text-bold">
                    {Number(row.piezas).toLocaleString('hr-HR', { maximumFractionDigits: 2 })}
                  </td>
                  <td data-label="Peso (kg)">{row.pesoKs} kg</td>
                  <td data-label="Biomasa (T)" className="text-biomasa">
                    {row.biomasa.toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </td>
                  <td data-label="Corral"><span className="badge-corral">{row.corral}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Table;